/* Selector de variantes, galería y agregar al carrito (vanilla). */
(() => {
  const root = document.querySelector('[data-product-section]');
  if (!root) return;
  const data = JSON.parse(root.querySelector('[data-product-json]').textContent);
  const form = root.querySelector('[data-product-form]');
  const idInput = root.querySelector('[data-variant-id]');
  const addBtn = root.querySelector('[data-add]');
  const addLabel = root.querySelector('[data-add-label]');
  const errEl = root.querySelector('[data-form-error]');
  const track = root.querySelector('[data-track]');
  const fieldsets = Array.from(root.querySelectorAll('[data-option-index]'));
  const S = window.YO.strings;
  if (idInput) idInput.disabled = false;

  const selected = () => fieldsets.map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
  const find = (opts) => data.variants.find((v) => v.options.every((o, i) => o === opts[i]));

  const markAvailability = (opts) => {
    fieldsets.forEach((fs, i) => {
      fs.querySelectorAll('.pdp__val').forEach((lbl) => {
        const input = lbl.querySelector('input');
        const test = opts.slice(); test[i] = input.value;
        const ok = data.variants.some((v) => v.available && v.options.every((o, k) => o === test[k]));
        lbl.classList.toggle('is-unavailable', !ok);
      });
      const sv = fs.querySelector('[data-selected-value]'); if (sv) sv.textContent = opts[i] || '';
    });
  };

  const goToMedia = (id, smooth = true) => {
    if (!track || !id) return;
    const slide = track.querySelector(`[data-media-id="${id}"]`);
    if (!slide) return;
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    root.querySelectorAll('[data-thumb]').forEach((t) => t.setAttribute('aria-current', t.dataset.thumb === String(id) ? 'true' : 'false'));
  };

  const update = () => {
    const opts = selected();
    const v = find(opts);
    markAvailability(opts);
    errEl.hidden = true;
    if (!v) {
      addBtn.disabled = true; addLabel.textContent = S.unavailable; return;
    }
    idInput.value = v.id;
    addBtn.disabled = !v.available || v.price === 0;
    addLabel.textContent = v.price === 0 ? S.priceOnRequest : v.available ? S.addToCart : S.soldOut;
    const priceBox = root.querySelector('[data-price] .price');
    if (priceBox) {
      const sale = v.compare > v.price;
      priceBox.classList.toggle('price--sale', sale);
      priceBox.innerHTML = (sale ? `<span class="visually-hidden">${S.regularPrice || ""}</span><s class="price__compare">${v.compareHtml}</s>` : '') + `<span class="price__current">${v.price === 0 ? S.priceOnRequest : v.priceHtml}</span>`;
    }
    const ref = root.querySelector('[data-ref]'); if (ref) { ref.textContent = v.sku || ''; ref.parentElement.hidden = !v.sku; }
    const w = root.querySelector('[data-weight]');
    if (w) { w.hidden = !v.hasWeight; root.querySelector('[data-weight-value]').textContent = v.weight; }
    if (v.media) goToMedia(v.media);
    const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
    history.replaceState({}, '', url.toString());
  };

  fieldsets.forEach((fs) => fs.addEventListener('change', update));
  if (fieldsets.length) markAvailability(selected());

  root.querySelectorAll('[data-thumb]').forEach((b) => b.addEventListener('click', () => goToMedia(b.dataset.thumb)));
  if (track) {
    let t;
    track.addEventListener('scroll', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        const slide = track.children[i];
        if (slide) root.querySelectorAll('[data-thumb]').forEach((b) => b.setAttribute('aria-current', b.dataset.thumb === slide.dataset.mediaId ? 'true' : 'false'));
      }, 80);
    }, { passive: true });
    const cur = root.querySelector('[data-thumb][aria-current="true"]');
    if (cur) goToMedia(cur.dataset.thumb, false);
  }

  form.addEventListener('submit', async (e) => {
    if (!window.YO.addToCart) return;
    e.preventDefault();
    if (addBtn.disabled) return;
    errEl.hidden = true;
    addLabel.textContent = S.adding;
    try { await window.YO.addToCart(new FormData(form), null); }
    catch (err) { errEl.textContent = err.message; errEl.hidden = false; }
    finally { const v = find(selected()) || data.variants.find((x) => String(x.id) === idInput.value); addLabel.textContent = v && v.price === 0 ? S.priceOnRequest : v && !v.available ? S.soldOut : S.addToCart; }
  });
})();
